import { get, post, apiPrefix } from '../api/common';
import { webApiResponseHandler } from './api';
const expenseReportApiPrefix = '/InternalAPI/ReportExecutiveAPI.asmx';
const createExpenseReportForReportExecutive = async (empId) => {
    const result = (await (await post(`${expenseReportApiPrefix}/RunReportExecutive`, { empId })).json()).d;
    if (result.Status !== 'success') {
        throw new Error(result.Message);
    }
    return JSON.parse(result.Data);
};
const runReportExecutive = async () => {
    const result = 0;
    return Promise.resolve(result);
};
const getExpenseReports = (options) => {
    const { EmployeeId, Processed, APSyncComplete, GLSyncComplete, IsPurchasingInvoice, IsInvoice, IncludeEmpName } = options;
    let query = '';
    if (EmployeeId)
        query += `EmployeeId=${EmployeeId}&`;
    if (Processed !== undefined)
        query += `Processed=${Processed}&`;
    if (APSyncComplete !== undefined)
        query += `APSyncComplete=${APSyncComplete}&`;
    if (GLSyncComplete !== undefined)
        query += `GLSyncComplete=${GLSyncComplete}&`;
    if (IsPurchasingInvoice !== undefined)
        query += `IsPurchasingInvoice=${IsPurchasingInvoice}&`;
    if (IsInvoice !== undefined)
        query += `IsInvoice=${IsInvoice}&`;
    if (IncludeEmpName !== undefined)
        query += `IncludeEmpName=${IncludeEmpName}&`;
    return get(`${apiPrefix}/expense-reports?${query}`).then(webApiResponseHandler);
};
const getExpenseReportById = (id) => get(`${apiPrefix}/expense-report/${id}`).then(webApiResponseHandler);
const getExpenseReportUrlById = (id) => get(`${apiPrefix}/expense-report/${id}/url`).then(webApiResponseHandler);
const updateExpenseReport = (payload) => post(`${apiPrefix}/expense-report`, { ...payload }).then(webApiResponseHandler);
export { createExpenseReportForReportExecutive, runReportExecutive, getExpenseReports, getExpenseReportById, getExpenseReportUrlById, updateExpenseReport };
